import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN_MENU_ITEMS_LIST } from "../../actions/types";
import { TransactionsService, MaterialReceivingService, CoreService } from "../../services";
import { MaterialReceivingEdit, TransactionsSummary } from './components';
import { ConfirmDialog } from "../../components/shared";
import SuccessDialog from '../../components/shared/SuccessDialog';
import { Typography } from "../../components/controls";
import clsx from 'clsx';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { Backdrop, Box, Button, Card, CardContent, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, MenuItem, IconButton, LinearProgress, Paper, TextField, Tooltip, useMediaQuery } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { DataGrid, GridRowsProp, GridColDef, GridOverlay } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { CogOutline, HelpCircleOutline, TrashCan, ArrowExpandHorizontal, ArrowCollapseHorizontal } from "mdi-material-ui";
import { red, green } from '@material-ui/core/colors';
import allowAction from '../../helpers/allowAction';
import _ from 'lodash';


function LoadingTableOverlay() {
    return (
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
            </div>
        </GridOverlay>
    );
}
export default function MaterialReceivingHome() {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems);

    // Loading
    const [isLoading, setIsLoading] = useState(true);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [editTicketData, setEditTicketData] = useState('');
    // Dialogs
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [successDialog, setSuccessDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    // Menu Item Dropdown
    const [searchFormData, setSearchFormData] = useState({ transactionType: 'GR', loadingDate: null, plant: '', storage: '', operationTeam: '', status: '', vehicleType: '' })
    const [searchAutocompleteData, setSearchAutocompleteData] = useState({ plant: { text: "", value: "" }, storage: { text: "", value: "" }, operationTeam: { text: "", value: "" }, status: { text: "", value: "" }, vehicleType: { text: "", value: "" }, tankTo: { text: "", value: "" }, unit: { text: "", value: "" } })
    const [dropdownStorageLocation, setDropdownStorageLocation] = useState([{ text: "Select a Plant first", value: "" }]);
    // Table
    const [visibilityTable, setVisibilityTable] = useState("hidden")
    //const [tableParameters, setTableParameters] = useState({ dataGridParameters: {}, dataGridSort: {} })
    const [tableParameters, setTableParameters] = useState({
        dataGridParameters: { "page": 0, "pageSize": 20 }, dataGridSort: {field: '', sort: ''}
    })

    //handle Expand/Collapse Grid
    const isLargeDisplay = useMediaQuery('(min-width: 1500px)');
    //use this to change container props. setting to {maxWidth: false} allows grid to expand full width
    const [containerProps, setContainerProps] = useState('');
    //Grid Actions toolip
    //...need these things to get better control of toolip or else it lingers on expand and collapse
    const [openTooltip, setOpenTooltip] = useState(false)
    const handleShowTooltip = () => {
        setOpenTooltip(true)
    }
    const handleHideTooltip = () => {
        setOpenTooltip(false)
    }


    const [fetchItem, setfetchItem] = useState({ result: [] });
    const [page, setPage] = React.useState(0);

    const [totalVolumes, setTotalVolumes] = React.useState({ totalSourceWeightNet: "-", totalDestinationWeightNet: "-", totalVendorDoWeight: "-", totalDiff: "-", totalDiffPercent: "-" });

    useEffect(() => {
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['sapPlant', 'operationTeam', 'status', 'vehicleType', 'sapStorageLocation', 'tank', 'unit']
        if (dropdownItemsStore) {
            for (var i = 0; i < dropdownToGet.length; i++) {
                if (dropdownItemsStore[dropdownToGet[i]].length !== 0) {
                    dropdownToGet = dropdownToGet.filter(function (item) {
                        return item !== dropdownToGet[i];
                    })
                }
            }
        }
        CoreService.dropdownItems(dropdownToGet).then(
            (response) => {
                if (response) {
                    const data = response.data;
                    dispatch({
                        type: SET_DROPDOWN_MENU_ITEMS_LIST,
                        payload: data,
                    });
                }
                setIsLoading(false);
            });
    }, [dispatch]);

    async function fetchTableDataWithFilter(filters) {
        setfetchItem({ result: [] })
        setTotalVolumes({ totalSourceWeightNet: "-", totalDestinationWeightNet: "-", totalVendorDoWeight: "-", totalDiff: "-", totalDiffPercent: "-" });
        setIsTableLoading(true);
        TransactionsService.searchTransactions(filters).then(
            (response) => {
                if (response.data) {
                    setfetchItem(response.data);
                    setTotalVolumes({
                        totalSourceWeightNet: response.data.totalSourceWeightNet,
                        totalVendorDoWeight: response.data.totalVendorDoWeight,
                        totalDiff: response.data.totalDiff,
                        totalDiffPercent: response.data.totalDiffPercent,
                    })
                }
                setIsTableLoading(false);
            });
    };
    const handleEditDialogClose = () => {
        setOpenEditDialog(false);
    }
    const handleSearchSubmit = (search) => {
        setVisibilityTable("visible");
        fetchTableDataWithFilter({ ...searchFormData, 'dataGridSort': { field: '', sort: '' }, 'dataGridParameters': {} });
    };
    const handleSearchFormChange = (target, fieldName) => {
        var value = target !== null ? target.value : ''
        var text = target !== null ? target.text : ''
        if (fieldName === 'plant') {
            var newStorageLocationList = dropdownItemsStore["sapStorageLocation"].filter(function (location) {
                return location.plant === value;
            });
            setDropdownStorageLocation(newStorageLocationList);
            setSearchAutocompleteData({ ...searchAutocompleteData, plant: { text, value }, storage: { text: '', value: '' } });
            setSearchFormData({ ...searchFormData, plant: value, storage: '' });
        }
        else {
            setSearchAutocompleteData({ ...searchAutocompleteData, [fieldName]: { text: text, value: value } })
            setSearchFormData({ ...searchFormData, [fieldName]: value });
        }
    };
    const handleSearchDateChange = (date) => {
        setSearchFormData({ ...searchFormData, ...tableParameters, loadingDate: date });
    };
    const handleReloadTable = () => {
        setIsTableLoading(true);
    };
    const handlePageSizeTransactionsTable = (event) => {
        setTableParameters({ ...tableParameters, 'dataGridParameters': { ...tableParameters.dataGridParameters, pageSize: event } })
        fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridParameters': { ...tableParameters.dataGridParameters, pageSize: event } });
    };
    const handlePageChangeTransactionsTable = (event) => {
        setTableParameters({ ...tableParameters, 'dataGridParameters': { page: event } })
        fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridParameters': { page: event } });
    };
    const handleSortTransactionsTable = (event) => {
        if (!_.isEqual(event[0], tableParameters.dataGridSort)) {
            if (event[0] && event[0].field) {
                setTableParameters({ ...tableParameters, 'dataGridSort': event[0] })
                fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridSort': event[0] });
            } else {
                setTableParameters({ ...tableParameters, 'dataGridSort': { field: '', sort: '' } })
                fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridSort': { field: '', sort: '' } });
            }
        }
    };
    const rows = useMemo(() => fetchItem.result, [fetchItem]);

    const columns = useMemo(() =>
        [
        {
            field: 'action', headerName: 'ACTION', width: 90, headerClassName: 'material-receiving-table--header', align: 'center', sortable: false,
            renderCell: (params) => {
                const onClickEdit = () => {
                    setEditTicketData(params.row);
                    setOpenEditDialog(true);
                };
                const onCancel = () => {
                    let formData = {
                        ticketId: params.row.ticketId,
                        status: "90",
                        slocTo: params.row.slocTo
                    }
                    TransactionsService.changeStatusByTicketId(formData).then((response) => {
                        setSuccessDialog({
                            isOpen: true,
                            title: 'Ticket Cancelled',
                            subTitle: <><Box component="div">The ticket status has been changed successfully</Box></>,
                        })
                        fetchTableDataWithFilter({ ...searchFormData, ...tableParameters });
                    })
                };
                return (<>
                    <IconButton aria-label="update" className={classes.margin} size="small" onClick={onClickEdit}>
                        <CogOutline />
                    </IconButton>
                    {allowAction("101", "cancel") ?
                        < IconButton aria-label="delete" className={classes.margin} size="small" onClick={onCancel}>
                            <TrashCan />
                        </IconButton>
                        : null
                    }
                </>);
            },
        },
        {
            field: 'ticketId', headerName: 'NO.', flex: 2, width: 180, headerClassName: 'material-receiving-table--header'
        },
        {
            field: 'loadingDate', headerName: 'LOADING DATE', flex: 1.5, width: 150, headerClassName: 'material-receiving-table--header',
            valueFormatter: (params) => (new Date(params.value)).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })
        },
        { field: 'plantTo', headerName: 'PLANT', flex: 1, width: 110, headerClassName: 'material-receiving-table--header' },
        { field: 'slocTo', headerName: 'STORAGE', flex: 1, width: 100, headerClassName: 'material-receiving-table--header' },
        { field: 'vehicleType', headerName: 'VEHICLE TYPE', flex: 1.25, width: 130, headerClassName: 'material-receiving-table--header' },
        {
            field: 'status', headerName: 'SUBMIT STATUS', flex: 1, width: 140, align: 'center', headerClassName: 'material-receiving-table--header',
            cellClassName: (params) => clsx('material-receiving-table', {
                error: params.value === 'Error',
                success: params.value === 'Success',
            }),
            valueFormatter: (params) => dropdownItemsStore["status"].filter(function (status) {
                return status.value === params.value;
            })[0].text,
        },
        { field: 'operationTeam', headerName: 'OPERATION TEAM', flex: 2, headerClassName: 'material-receiving-table--header' },
        ], [fetchItem]);

    return (
        <>
            <Container id='containerMR'{...containerProps}>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Material Receiving
                    </h2>
                </div>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Card className={classes.root}>
                        <CardContent>
                            <form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={10} lg={10}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <Grid container justify="space-around">
                                                        <KeyboardDatePicker
                                                            disableToolbar
                                                            autoOk={true}
                                                            size="small"
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd-MMM-yyyy"
                                                            id="loadingDate"
                                                            label="Loading Date"
                                                            value={searchFormData.loadingDate}
                                                            onChange={handleSearchDateChange}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchPlantList"
                                                    name="searchPlantList"
                                                    options={dropdownItemsStore["sapPlant"]}
                                                    value={{ text: searchAutocompleteData.plant.text, value: searchAutocompleteData.plant.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'plant');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchPlantList"
                                                        name="searchPlantList"
                                                        label="Plant"
                                                        //placeholder={"Plants"}
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchStorageList"
                                                    name="searchStorageList"
                                                    options={dropdownStorageLocation}
                                                    value={{ text: searchAutocompleteData.storage.text, value: searchAutocompleteData.storage.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    getOptionDisabled={(option) => option.value === ""}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'storage');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchStorageList"
                                                        name="searchStorageList"
                                                        label="Storage"
                                                        //placeholder={"Storage"}
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchOperationTeamList"
                                                    name="searchOperationTeamList"
                                                    options={dropdownItemsStore["operationTeam"]}
                                                    value={{ text: searchAutocompleteData.operationTeam.text, value: searchAutocompleteData.operationTeam.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'operationTeam');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchOperationTeamList"
                                                        name="searchOperationTeamList"
                                                        label="Operation Team"
                                                        //placeholder={"Operation Team"}
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchVehicleTypeList"
                                                    name="searchVehicleTypeList"
                                                    options={dropdownItemsStore["vehicleType"]}
                                                    value={{ text: searchAutocompleteData.vehicleType.text, value: searchAutocompleteData.vehicleType.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'vehicleType');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchVehicleTypeList"
                                                        name="searchVehicleTypeList"
                                                        label="Vehicle Type"
                                                        //placeholder={"Operation Team"}
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Autocomplete
                                                    id="searchStatusList"
                                                    name="searchStatusList"
                                                    options={dropdownItemsStore["status"]}
                                                    value={{ text: searchAutocompleteData.status.text, value: searchAutocompleteData.status.value }}
                                                    getOptionLabel={(option) => option.text}
                                                    getOptionSelected={(option, value) => option.text === value.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFormChange(newValue, 'status');
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchStatusList"
                                                        name="searchStatusList"
                                                        label="Ticket Status"
                                                        //placeholder={"Ticket Status"}
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <Grid container spacing={1} style={{ textAlign: "center" }}>
                                            <Grid item xs={12}>
                                                <Button style={{ width: '100%' }} variant="contained" onClick={handleSearchSubmit}>Search</Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {allowAction("101", "create") ?
                                                    <Button style={{ width: '100%' }} color="primary" variant="contained" onClick={() => history.push('/purchase/material-receiving/create')}>Create New</Button>
                                                    : null}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {isLargeDisplay && visibilityTable === 'visible' ?
                        <div className={classes.gridActionsContainer}>
                            <Tooltip
                                title={!containerProps ? 'Expand' : 'Collapse'}
                                open={openTooltip}
                                placement='top'
                            >
                                <IconButton
                                    onMouseEnter={handleShowTooltip}
                                    onMouseLeave={handleHideTooltip}
                                    onClick={() => {
                                        if (!containerProps) {
                                            setContainerProps({ maxWidth: false })
                                        } else {
                                            setContainerProps('')
                                        }
                                        handleHideTooltip()

                                    }
                                    }>
                                    {!containerProps ?
                                        <ArrowExpandHorizontal />
                                        :
                                        <ArrowCollapseHorizontal />
                                    }
                                </IconButton>
                            </Tooltip>
                        </div>
                        :
                        null
                    }

                    <Box px={1.5} visibility={visibilityTable} className={classes.materialReceivingTable}>
                        <div style={{ height: 600, width: "100%" }}>
                            <DataGrid
                                loading={isTableLoading}
                                className={classes.table}
                                rows={rows}
                                columns={columns}
                                pageSize={tableParameters?.dataGridParameters?.pageSize ?? 20}
                                page={fetchItem.page}
                                rowCount={fetchItem.rowCount}
                                rowsPerPageOptions={[20]}
                                pagination
                                disableColumnMenu={true}
                                disableColumnSelector={true}
                                disableMultipleSelection={true}
                                getRowId={(row) => row.ticketId}
                                paginationMode="server"
                                sortingMode="server"
                                onPageSizeChange={handlePageSizeTransactionsTable}
                                onPageChange={handlePageChangeTransactionsTable}
                                onSortModelChange={handleSortTransactionsTable}
                            />
                        </div>
                        <Box py={2}>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                spacing={1}
                            >
                                <Grid item xs={3}>
                                    <Paper style={{ height: 75, padding: 5, marginRight: 10, textAlign: "center" }} elevation={3}>
                                        <TransactionsSummary title="Total Net Weight" value={totalVolumes.totalSourceWeightNet} />
                                    </Paper>
                                </Grid>
                                <Grid item xs={3}>
                                    <Paper style={{ height: 75, padding: 5, marginRight: 10, textAlign: "center" }} elevation={3}>
                                        <TransactionsSummary title="Total Do Weight" value={totalVolumes.totalVendorDoWeight} />
                                    </Paper>
                                </Grid>
                                <Grid item xs={3}>
                                    <Paper style={{ height: 75, padding: 5, marginRight: 10, textAlign: "center" }} elevation={3}>
                                        <TransactionsSummary title="Total Diff." value={totalVolumes.totalDiff} colorize={true} />
                                    </Paper>
                                </Grid>
                                <Grid item xs={3}>
                                    <Paper style={{ height: 75, padding: 5, textAlign: "center" }} elevation={3}>
                                        <TransactionsSummary title="Total Diff. %" value={totalVolumes.totalDiffPercent + "%"} colorize={true} />
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
                {openEditDialog ?
                    <MaterialReceivingEdit handleSearchSubmit={handleSearchSubmit} transactionData={editTicketData} open={openEditDialog} onClose={handleEditDialogClose} /> : ''
                }
            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <SuccessDialog
                successDialog={successDialog}
                setSuccessDialog={setSuccessDialog}
            />
            <Backdrop className={classes.backdrop} open={isLoading} timeout={{ enter: 1100 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
const useStyles = makeStyles((theme) => ({
    gridActionsContainer: {
        display: 'flex',
        width: '100%',
        height: 32,
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: theme.palette.background.paper,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4
    },
    materialReceivingTable: {
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .material-receiving-table.error': {
            backgroundColor: red[100],
            color: red[600],
        },
        '& .material-receiving-table.success': {
            backgroundColor: green[100],
            color: green[600],
        },
        '& .material-receiving-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }

    },
    table: {
        backgroundColor: theme.palette.background.paper,

    },
    addMaterialReceiving: {
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
}));